import { render } from "./DespachosIndex.vue?vue&type=template&id=44899d18"
import script from "./DespachosIndex.vue?vue&type=script&lang=js"
export * from "./DespachosIndex.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/despachos/DespachosIndex.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "44899d18"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('44899d18', __exports__)) {
    api.reload('44899d18', __exports__)
  }
  
  module.hot.accept("./DespachosIndex.vue?vue&type=template&id=44899d18", () => {
    api.rerender('44899d18', render)
  })

}


export default __exports__